import { useSetAtom } from "jotai";
import { useClientsState } from "atoms/clientsAtom";
import {
  setClientGroupAtom,
  setConfirmationModalAtom,
  setInfoModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { deleteClientGroup, useDeleteClientGroup } from "./api";

export const ClientGroupFooter = (): JSX.Element => {
  const { clientsState } = useClientsState();
  const setClientGroupInfo = useSetAtom(setClientGroupAtom);
  const setConfirmModal = useSetAtom(setConfirmationModalAtom);
  const closeDeleteModal = useSetAtom(setModalCloseAtom);
  const setInfoModal = useSetAtom(setInfoModalAtom);

  const onConfirm = async () => {
    try {
      await deleteClientGroup(
        clientsState.activeGroupItem?.clientgroupid || ""
      );
      closeDeleteModal();
    } catch (e: any) {
      setInfoModal({ title: e?.response?.data?.message || "Ошибка" });
    }
  };

  const handleInfoClick = () => {
    if (clientsState.activeGroupItem) {
      setClientGroupInfo(true);
    }
  };

  const handleDeleteClick = () => {
    if (clientsState.activeGroupItem) {
      setConfirmModal({
        title: `Вы действительно хотите удалить группу "${clientsState.activeGroupItem.name}"?`,
        onConfirm,
      });
    }
  };

  return (
    <div className="flex flex-row ">
      <Button icon="plus" onClick={() => setClientGroupInfo(false)}>
        Добавить группу
      </Button>
      <HorizontalSpace size={11} />
      <Button
        icon="delete"
        onClick={handleDeleteClick}
        disabled={!clientsState.activeGroupItem}
      />
      <HorizontalSpace size={11} />
      <Button
        onClick={handleInfoClick}
        icon="info"
        disabled={!clientsState.activeGroupItem}
      />
    </div>
  );
};
